import { Card } from "react-bootstrap";
import "../../../../components/CatalogIndex/CatalogIndex.css";

export const SERVICE_ACCOUNT_DOCS_URL =
  "https://docs.scopestack.io/help/integrations/service-account-credentials";

export const ServiceAccountNotice = (): JSX.Element => (
  <div className="admin-form-card">
    <Card>
      <Card.Body style={{ padding: "16px" }}>
        <h4>Configure OAuth2 with Service Accounts</h4>
        <p>
          Account-wide OAuth2 callbacks have been replaced. Instead of one
          shared callback for the whole account, configure OAuth2 API access by
          creating credentials on a service account.
        </p>
        <a
          href={SERVICE_ACCOUNT_DOCS_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn how to configure service account credentials
        </a>
      </Card.Body>
    </Card>
  </div>
);

export default ServiceAccountNotice;
